import VidstackPlayer from "@/components/VidstackPlayer/VidstackPlayer";
import { useCarouselExtraContext } from "@/context/CarouselExtraContext";
import { HeaderVideosType } from "@/types/PageType";
import React from "react";

function HeroVideo({
  data,
  index,
  autoplay,
}: {
  data: HeaderVideosType;
  index: number;
  autoplay: boolean;
}) {
  const { activeIndex } = useCarouselExtraContext();
  const isActive = activeIndex === index;
  return (
    <VidstackPlayer
      video={data}
      autoplay={autoplay}
      muted
      controls={false}
      heroSliderActiveSlide={isActive}
      headerVideo
      loop
    />
  );
}

export default HeroVideo;
